export const PAYMENT_TYPE_OTHER_LABEL = 'Other';
export const PAYMENT_TYPE_OTHER_ID = '65f062bc2d71dfb4e188011b';

export const PAYMENT_TYPE_OTHER = {_id: PAYMENT_TYPE_OTHER_ID, label: PAYMENT_TYPE_OTHER_LABEL};

export const SESSION_FEE = {
    _id: '65f062bc2d71dfb4e188010b',
    label: 'Session Fee',
    description: 'Session fee charged by CMC for conflict resolution services',
};
export const OTHER_FEE = {_id: PAYMENT_TYPE_OTHER_ID, label: 'Other'};
export const TRAINING_FEE = {
    _id: '65f062bc2d71dfb4e188012b',
    label: 'Training Fee',
    description: 'Training fee charged by CMC for training service provided',
};
export const GRANT_AWARD = {
    _id: '65f062bc2d71dfb4e188013b',
    label: 'Grant Award',
    description: 'Grant amount awarded to CMC',
};
export const DONATION = {_id: '65f062bc2d71dfb4e188014b', label: 'Donation', description: 'Donation received by CMC'};
export const TRAINER_PAYMENT = {
    _id: '65f062bc2d71dfb4e188016b',
    label: 'Trainer Payment',
    description: 'Payment made to trainer by CMC',
};
export const COACH_PAYMENT = {
    _id: '65f062bc2d71dfb4e188017b',
    label: 'Coach Payment',
    description: 'Payment made to role play coach by CMC',
};
export const MEDIATOR_PAYMENT = {
    _id: '65f062bc2d71dfb4e188018b',
    label: 'Mediator Payment',
    description: 'Payment made to mediator by CMC',
};
export const FC_KEEPER_PAYMENT = {
    _id: '65f062bc2d71dfb4e188019b',
    label: 'Facilitator/Circle Keeper payment',
    description: 'Payment made to Facilitator/Circle Keeper by CMC',
};
export const FACILITATION_FEE = {
    _id: '65f062bc2d71dfb4e188015b',
    label: 'Facilitation Fee',
    description: 'Facilitation fee charged by CMC for facilitation service provided',
};
